import type { PartImageEthnicity } from "~/database/types";

// AIDEV-NOTE: User-facing labels for the ethnicity dropdown. Shared between the
// preferences modal and the onboarding wizard so they stay in lockstep.
// Keep "Prefer not to say" last; it avoids explicit race guidance without
// forcing the backend to ABSTRACT.
export const ETHNICITY_OPTIONS: ReadonlyArray<{
    value: PartImageEthnicity;
    label: string;
}> = [
    { value: "east_asian", label: "East Asian" },
    { value: "south_asian", label: "South Asian" },
    { value: "black_or_african", label: "Black / African diaspora" },
    { value: "white", label: "White" },
    { value: "latino_hispanic", label: "Latino / Hispanic" },
    { value: "mena", label: "Middle Eastern / North African" },
    { value: "indigenous", label: "Indigenous / First Nations" },
    { value: "mixed_multiracial", label: "Mixed / multiracial" },
    { value: "prefer_not_to_say", label: "Prefer not to say" },
];
